export const Title = ({ blue, black }) => {
  return (
    <h2>
      <span className="heading heading__ternary  text--black">{black} </span>
      <span className="heading heading__secondary text--blue">{blue}</span>
    </h2>
  );
};
